import { ValidationArgs } from '@vuelidate/core';
import { email, required } from '@vuelidate/validators';

export class ContactUsVm {
    name:string = '';
    schoolOrCompanyName:string = '';
    email:string = '';
    phoneNumber:string = '';
    subject: string = '';
    message: string = '';
} 

export const ContactUsVmValidationRules: ValidationArgs<ContactUsVm> = {
    name: { required },
    schoolOrCompanyName: { required },
    email: { required, email },
    phoneNumber: { required },
    subject: { required },
    message: { required },
}